import { FC } from 'react';

import { Button } from '../../../components/ui/Button';
import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '../../../components/ui/Dialog';
import { Input } from '../../../components/ui/Input';

interface Props {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    mode: 'add' | 'edit';
    trackingNumber: string;
    onTrackingNumberChange: (value: string) => void;
    trackingError: string;
    onSubmit: () => void;
    disabled: boolean;
    processing: boolean;
}

export const SalesTrackingDialog: FC<Props> = ({
    open,
    onOpenChange,
    mode,
    trackingNumber,
    onTrackingNumberChange,
    trackingError,
    onSubmit,
    disabled,
    processing,
}) => {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="sm:max-w-[425px]">
                <DialogHeader>
                    <DialogTitle>
                        {mode === 'edit'
                            ? 'Змінити ТТН'
                            : 'Додати трек-номер (ТТН)'}
                    </DialogTitle>
                </DialogHeader>
                <div className="space-y-3">
                    <p className="text-sm text-muted-foreground">
                        {mode === 'edit'
                            ? 'Оновіть номер товарно-транспортної накладної.'
                            : 'Введіть номер товарно-транспортної накладної. Покупець отримає повідомлення.'}
                    </p>
                    <Input
                        id="tracking-number"
                        value={trackingNumber}
                        onChange={(e) => onTrackingNumberChange(e.target.value)}
                        className={
                            trackingError
                                ? 'col-span-3 border-red-500'
                                : 'col-span-3'
                        }
                        placeholder="Введіть трек-номер"
                    />
                    {trackingError && (
                        <p className="text-sm text-red-600">{trackingError}</p>
                    )}
                </div>
                <DialogFooter>
                    <Button
                        className="w-full"
                        type="button"
                        onClick={onSubmit}
                        disabled={disabled || processing}
                    >
                        {mode === 'edit'
                            ? 'Зберегти ТТН'
                            : 'Підтвердити відправку'}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};
